module.exports = __webpack_public_path__ + "f0f382a943f7b2dced756fb3be7f7f0a.png";